import { withInstall } from '@bigin/utils'

import Alert from './src/alert.vue'

export const BAlert = withInstall(Alert)
export default BAlert

export * from './src/alert'
